// import { COPY_SUCCESS_MESSAGE, COPY_SUCCESS_MESSAGE_NOLOGIN } from '../../utils/constant';
// export const copySuccessMessage = COPY_SUCCESS_MESSAGE;
export const wechatMessage = '微信扫码，分享给好友，分享成功即可获得积分';
export const momentsMessage = '微信扫码，分享到朋友圈，分享成功即可获得积分';
export const wechatMessageNoLogin = '微信扫码，分享给好友，登录后分享成功即可获得积分';
export const momentsMessageNoLogin = '微信扫码，分享到朋友圈，登录后分享成功即可获得积分';
export const linkShareContent = '复制以下文字发送给好友，邀请他们来CNABS';

export const shareHtmlType = {
  dailyReport: 3,
  expertResume: 9
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSShare/util.ts